<template>
  <fh-container justify-center>
    <v-card>
      <v-card-title primary-title>
        <div class="text-md-h5 text-subtitle-1 text-break text-center">
          {{ establecimiento.nombre }}
        </div>
        <v-spacer />
        <fh-establecimiento-menu
          v-on:changeEstablecimiento="handleElegirEstablecimiento"
        ></fh-establecimiento-menu>
      </v-card-title>

      <v-card-subtitle>Configuración del establecimiento</v-card-subtitle>
      <v-divider></v-divider>

      <v-card-text>
        <v-card class="mb-2 pb-5" tile flat>
          <v-row align="center" class="mb-1 text-md-left text-center">
            <v-col cols="12" sm="12" md="10" class="py-0">
              <v-card-subtitle v-if="establecimiento.zona" class="px-0">
                <div class="bottom grey--text text-subtitle-1 text-break">
                  <v-row class="mb-1" no-gutters style="flex-wrap: nowrap">
                    <v-col
                      class="py-0 flex-grow-0 flex-shrink-0"
                      cols="12"
                      sm="7"
                    >
                      <strong>Zona: </strong>{{ establecimiento.zona.nombre }}
                      <template v-for="grupo in grupoExplotacionList">
                        <span
                          :key="`${grupo.idGrupoExplotacion}${grupo.nombre}`"
                          class="grey--text body-1 mr-2"
                          ><v-icon
                            right
                            left
                            color="brown"
                            :key="`${grupo.idGrupoExplotacion}${establecimiento.idEstablecimiento}`"
                            v-if="grupo.categoria === 2"
                            >{{ cowIcon }}</v-icon
                          >
                          <v-icon
                            right
                            left
                            color="primary"
                            :key="`${grupo.idGrupoExplotacion}${establecimiento.idEstablecimiento}`"
                            v-else
                            >fa-seedling</v-icon
                          >
                          {{ grupo.nombre }}</span
                        >
                      </template>
                    </v-col>
                  </v-row>
                </div>
              </v-card-subtitle>
            </v-col>
            <v-col class="py-0">
              <div :class="{ 'float-right': !$vuetify.breakpoint.mobile }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="editarEstablecimiento(establecimiento)"
                    >
                      <v-icon color="primary" small>fa-pen</v-icon>
                    </v-btn>
                  </template>
                  <span>Modificar Establecimiento</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="deleteEstablecimiento(establecimiento)"
                    >
                      <v-icon color="red" small>fa-trash</v-icon>
                    </v-btn>
                  </template>
                  <span>Borrar Establecimiento</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-card-actions class="px-0">
            <v-row style="flex-wrap: nowrap">
              <v-col class="pt-0 flex-grow-0 flex-shrink-0" cols="12" sm="12">
                <v-btn
                  v-if="
                    currentCategoria === 2 &&
                    fichaGanadera != null &&
                    fichaGanadera.idFichaGanadera != null
                  "
                  small
                  outlined
                  class="mt-1 mr-1"
                  @click="showAdvanced = !showAdvanced"
                >
                  Configuración ganadería<v-icon right>{{
                    showAdvanced ? "fa-chevron-up" : "fa-chevron-down"
                  }}</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    currentCategoria === 2 &&
                    !establecimiento.hasAgro &&
                    canAddExplotacionAgricola
                  "
                  small
                  outlined
                  color="primary"
                  class="mt-1 mr-1"
                  @click="agregarExplotacion(1)"
                >
                  Agregar Agricultura
                  <v-icon right>fa-seedling</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    !establecimiento.hasGanaderia && canAddExplotacionGanadera
                  "
                  small
                  outlined
                  color="primary"
                  class="mt-1 mr-1"
                  @click="agregarExplotacion(2)"
                >
                  Agregar Ganadería
                  <v-icon right>{{ cowIcon }}</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    establecimiento.hasAgro &&
                    establecimiento.grupoExplotacionList.length !== 1
                  "
                  class="mt-1 mr-1"
                  small
                  outlined
                  color="red"
                  @click="abirDebajaExplotacion(1)"
                >
                  Debaja Agricultura
                  <v-icon right>fa-seedling</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    establecimiento.hasGanaderia &&
                    establecimiento.grupoExplotacionList.length !== 1
                  "
                  class="mt-1 mr-1"
                  small
                  outlined
                  color="red"
                  @click="abirDebajaExplotacion(2)"
                >
                  Debaja Ganadería
                  <v-icon right>{{ cowIcon }}</v-icon>
                </v-btn>
                <fh-debaja-ficha-ganadera
                  v-if="
                    currentCategoria === 2 &&
                    fichaGanadera != null &&
                    fichaGanadera.idFichaGanadera != null
                  "
                ></fh-debaja-ficha-ganadera>
              </v-col>
            </v-row>
            <!-- <v-btn
              small
              outlined
              color="red"
              @click="addFichaGanadera"
              rounded
            >
              Ficha
            </v-btn> -->
          </v-card-actions>
          <v-expand-transition v-if="establecimiento.hasGanaderia">
            <div v-show="showAdvanced">
              <v-card flat>
                <v-form ref="form" v-model="valid">
                  <v-card-text class="pb-0 px-0">
                    <div class="text-left text-subtitle-1">
                      Configuración de la explotación ganadera
                    </div>
                  </v-card-text>
                  <v-card-text
                    class="py-0 text-left px-0"
                    v-if="parcelas.length === 0"
                  >
                    Para trabajar en la explotación ganadera primeramente debe
                    definir la manera de trabajar.
                    <br />
                    Debe definir la superficie de la explotación ganadera. Esta
                    superficie influye en el cálculo de resultados y resúmenes.
                    <br />
                    <br />
                    <strong>Las opciones de configuración son:</strong>
                    <br />
                    <strong>- Opción 1:</strong> Trabajar sobre un total de ha.
                    Se define la superficie y toda actividad se calcula sobre
                    esta superficie.
                    <br />
                    <strong>- Opción 2:</strong> División en retiros, para cada
                    retiro se define un nombre y una superficie. Se podrán
                    generar resúmenes por retiro. También es posible dividir
                    cada retiro en parcelas.
                    <br />
                    <strong>- Opción 3:</strong> División en parcelas. Se podrá
                    cargar movimientos relacionados a parcelas. Para cada
                    parcela se define un nombre y la superficie.
                    <br />
                    <br />
                    <div class="text--secondary">
                      obs. Podrá cambiar la configuración en cualquier momento
                      pero puede ser que se pierdan datos al hacer eso.
                    </div>
                  </v-card-text>
                  <v-radio-group v-model="optionRadio" column class="mt-0">
                    <!-- Opcion 1: Configuración default con una Parcela -->
                    <v-card
                      class="mb-5"
                      flat
                      :class="{
                        'fh-new':
                          parcelas.length === 0 ||
                          parcelas.length > 1 ||
                          listaRetiros.length !== 0 ||
                          parcelaChange,
                        'fh-saved': parcelas.length === 1 && !parcelaChange,
                      }"
                    >
                      <v-card-title>
                        <v-chip color="primary" text-color="white"
                          >Opción
                          <v-avatar right class="green darken-4"> 1 </v-avatar>
                        </v-chip>
                        <v-dialog v-model="opcionUno" width="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="red lighten-2"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              icon
                            >
                              <v-icon>fa-question-circle</v-icon>
                            </v-btn>
                          </template>

                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Configuración opción 1
                            </v-card-title>

                            <v-card-text>
                              En esta configuración, la explotación ganadera se
                              maneja como una superficie total. Esta es la
                              configuración por defecto. Toda actividad y
                              registro se calcula sobre las hectáres
                              especificadas. Si no quiere administrar su
                              explotación ganadera en retiros o parcelas eliga
                              esta opción y entre las hectáres totales de
                              trabajo.
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                text
                                @click="opcionUno = false"
                              >
                                Cerrar
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-card-title>
                      <v-radio
                        label="Configuración con Total de ha"
                        :value="1"
                        class="my-2 pl-4"
                        @change="checkUno"
                      ></v-radio>
                      <v-card-text v-if="optionRadio === 1">
                        <fh-number
                          v-model="editedParcela.superficie"
                          label="Total Ha para explotación ganadera"
                          maximumFractionDigits="2"
                          :disabled="optionRadio !== 1"
                          :rules="nonNegativeRules"
                          @input="changeDefault"
                        ></fh-number>

                        <v-text-field
                          v-model="editedParcela.comentario"
                          label="Comentario"
                          :rules="comentarioRules"
                          :counter="comentarioLength"
                          :disabled="optionRadio !== 1"
                          @input="changeDefault"
                        ></v-text-field>
                      </v-card-text>

                      <v-card-actions
                        v-if="optionRadio === 1"
                        class="justify-end pr-4"
                      >
                        <v-btn
                          :disabled="optionRadio !== 1"
                          @click="cancelSaveParcelaUnica"
                          outlined
                          >Cancelar</v-btn
                        >
                        <v-btn
                          :disabled="optionRadio !== 1"
                          @click="handleSaveParcelaUnica"
                          color="success"
                          outlined
                          >Guardar</v-btn
                        >
                      </v-card-actions>
                    </v-card>

                    <!-- Opcion 2: Configuración en Retiros -->
                    <v-card outlined flat class="pt-0 mb-5">
                      <v-card-title>
                        <v-chip color="primary" text-color="white"
                          >Opción
                          <v-avatar right class="green darken-4"> 2 </v-avatar>
                        </v-chip>
                        <v-dialog v-model="opcionDos" width="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="red lighten-2"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              icon
                            >
                              <v-icon>fa-question-circle</v-icon>
                            </v-btn>
                          </template>

                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Configuración opción 2
                            </v-card-title>

                            <v-card-text>
                              En esta configuración, la explotación ganadera se
                              divide en retiros. Para cada retiro se guarda la
                              superficie de explotación.
                              <p></p>
                              <span class="font-weight-bold">Opcional</span>
                              <p>
                                Si desesa, también puede dividir cada retiro en
                                sub-parcelas. En este caso tendrá que
                                especificar para cada parcela la superficie de
                                explotación.
                              </p>
                              <p>
                                Para trabajar con esta ultima configuración de
                                divición en retiros con subparcelas, seleccione
                                la opción
                                <span class="font-weight-bold"
                                  >"Subdividir los retiros en parcelas"</span
                                >
                              </p>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                text
                                @click="opcionDos = false"
                              >
                                Cerrar
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-card-title>
                      <v-radio
                        label="Dividir establecimiento en retiros"
                        :value="2"
                        class="mt-2 pl-4"
                        @change="checkDos"
                      ></v-radio>
                      <v-subheader class="py-0 black--text">
                        Retiros
                        <v-btn icon @click="showRetiros = !showRetiros">
                          <v-icon small>{{
                            showRetiros ? "fa-chevron-up" : "fa-chevron-down"
                          }}</v-icon>
                        </v-btn>
                      </v-subheader>
                      <v-expand-transition>
                        <div v-show="showRetiros">
                          <v-card-text class="py-0">
                            <v-checkbox
                              label="Subdividir los retiros en parcelas"
                              v-model="retiroParcelaSwitch"
                              class="mt-0 pt-0 pr-6"
                              :disabled="optionRadio !== 2"
                            >
                            </v-checkbox>

                            <template>
                              <!-- retiros guardados -->
                              <v-card
                                v-for="(retiro, index) in retirosSaved"
                                :key="'retirosSaved-' + index"
                                class="mb-5 fh-saved"
                                flat
                              >
                                <v-card-text>
                                  <v-btn
                                    @click="eliminarRetiroSaved(index, retiro)"
                                    fab
                                    small
                                    top
                                    right
                                    depressed
                                    absolute
                                    class="fh-fab-btn"
                                  >
                                    <v-icon>fa-times</v-icon>
                                  </v-btn>

                                  <v-text-field
                                    v-model="retiro.nombre"
                                    label="Nombre del retiro"
                                    ref="nombreSaved"
                                    :rules="commonRules"
                                    :counter="retiroNombreLength"
                                    dense
                                    class="pb-2"
                                  >
                                  </v-text-field>
                                  <fh-number
                                    v-if="
                                      retiro.superficie !== 0 &&
                                      !retiroParcelaSwitch
                                    "
                                    v-model="retiro.superficie"
                                    label="Total Ha para explotación ganadera"
                                    maximumFractionDigits="2"
                                    :rules="nonNegativeRules"
                                    dense
                                  ></fh-number>

                                  <template v-if="retiroParcelaSwitch">
                                    <v-subheader class="pl-0 black--text"
                                      >Parcelas</v-subheader
                                    >
                                    <!-- parcelas guardadas -->
                                    <v-card
                                      v-for="(
                                        parcela, indexParcela
                                      ) in retiro.parcelasSaved"
                                      :key="'parcelaSaved-' + indexParcela"
                                      class="mt-5 mb-5 fh-saved"
                                      flat
                                    >
                                      <v-card-text>
                                        <v-btn
                                          v-if="retiro.parcelasSaved.length > 1"
                                          @click="
                                            eliminarParcelaRetiroSaved(
                                              index,
                                              indexParcela,
                                              parcela
                                            )
                                          "
                                          fab
                                          small
                                          top
                                          right
                                          depressed
                                          absolute
                                          class="fh-fab-btn"
                                        >
                                          <v-icon>fa-times</v-icon>
                                        </v-btn>

                                        <v-text-field
                                          v-model="parcela.nombre"
                                          label="Nombre de la parcela"
                                          :rules="commonRules"
                                          :counter="parcelaNombreLength"
                                          dense
                                          class="pb-2"
                                        >
                                        </v-text-field>

                                        <fh-number
                                          v-model="parcela.superficie"
                                          label="Total Ha"
                                          maximumFractionDigits="2"
                                          :rules="nonNegativeRules"
                                          dense
                                          class="pb-2"
                                        ></fh-number>

                                        <v-text-field
                                          v-model="parcela.comentario"
                                          label="Comentario"
                                          :rules="comentarioRules"
                                          :counter="comentarioLength"
                                          dense
                                        >
                                        </v-text-field>
                                      </v-card-text>
                                    </v-card>
                                    <!-- parcelas nuevas -->
                                    <v-card
                                      v-for="(
                                        parcela, indexParcela
                                      ) in retiro.parcelasRetiroTemp"
                                      :key="'parcelaRetiroTemp-' + indexParcela"
                                      class="mb-5 fh-new"
                                      flat
                                    >
                                      <v-card-text>
                                        <v-btn
                                          @click="
                                            eliminarParcelaRetiroTemp(
                                              index,
                                              indexParcela
                                            )
                                          "
                                          fab
                                          small
                                          top
                                          right
                                          depressed
                                          absolute
                                          class="fh-fab-btn"
                                        >
                                          <v-icon>fa-times</v-icon>
                                        </v-btn>

                                        <v-text-field
                                          v-model="parcela.nombre"
                                          label="Nombre"
                                          ref="nombre"
                                          :rules="commonRules"
                                          :counter="parcelaNombreLength"
                                          dense
                                          class="pb-2"
                                        >
                                        </v-text-field>

                                        <fh-number
                                          v-model="parcela.superficie"
                                          label="Total Ha"
                                          maximumFractionDigits="2"
                                          :rules="nonNegativeRules"
                                          dense
                                          class="pb-2"
                                        ></fh-number>

                                        <v-text-field
                                          v-model="parcela.comentario"
                                          label="Comentario"
                                          :rules="comentarioRules"
                                          :counter="comentarioLength"
                                          dense
                                        >
                                        </v-text-field>
                                      </v-card-text>
                                    </v-card>
                                    <!-- parcelas a eliminar -->
                                    <v-card
                                      v-for="(
                                        parcela, indexParcela
                                      ) in retiro.parcelasListToDelete"
                                      :key="
                                        'parcelasSavedEliminar-' + indexParcela
                                      "
                                      class="mb-5 fh-eliminar"
                                      flat
                                    >
                                      <v-card-text>
                                        <v-btn
                                          @click="
                                            revertirParcelaRetiroSaved(
                                              index,
                                              indexParcela,
                                              parcela
                                            )
                                          "
                                          fab
                                          small
                                          top
                                          right
                                          depressed
                                          absolute
                                          class="fh-fab-btn"
                                        >
                                          <v-icon>fa-undo-alt</v-icon>
                                        </v-btn>
                                        Parcela a eliminar
                                        <v-text-field
                                          v-model="parcela.nombre"
                                          label="Nombre"
                                          ref="nombreDelete"
                                          :rules="commonRules"
                                          :counter="parcelaNombreLength"
                                          readonly
                                          dense
                                          class="pb-2"
                                        >
                                        </v-text-field>
                                        <fh-number
                                          v-model="parcela.superficie"
                                          label="Total Ha"
                                          maximumFractionDigits="2"
                                          :rules="nonNegativeRules"
                                          readonly
                                          dense
                                          class="pb-2"
                                        ></fh-number>
                                        <v-text-field
                                          v-model="parcela.comentario"
                                          label="Comentario"
                                          :rules="comentarioRules"
                                          :counter="comentarioLength"
                                          readonly
                                          dense
                                        >
                                        </v-text-field>
                                      </v-card-text>
                                    </v-card>
                                  </template>

                                  <v-btn
                                    v-if="retiroParcelaSwitch"
                                    @click="agregarParcelaRetiroSaved(index)"
                                    outlined
                                    rounded
                                    color="#90caf9"
                                    class="mt-1 mb-4"
                                  >
                                    <v-icon left small>fa-plus</v-icon>
                                    Agregar Parcela
                                  </v-btn>
                                </v-card-text>
                              </v-card>
                              <!-- retiros nuevos -->
                              <v-card
                                v-for="(retiro, index) in retirosTemp"
                                :key="'retiro-' + index"
                                class="mb-5 fh-new"
                                flat
                                ref="retiro"
                              >
                                <v-card-text>
                                  <v-btn
                                    @click="eliminarRetiroTemp(index)"
                                    fab
                                    small
                                    top
                                    right
                                    depressed
                                    absolute
                                    class="fh-fab-btn"
                                  >
                                    <v-icon>fa-times</v-icon>
                                  </v-btn>

                                  <v-text-field
                                    v-model="retiro.nombre"
                                    label="Nombre del retiro"
                                    ref="nombreNuevo"
                                    :disabled="optionRadio !== 2"
                                    :rules="commonRules"
                                    :counter="retiroNombreLength"
                                    dense
                                    class="pb-2"
                                  >
                                  </v-text-field>

                                  <fh-number
                                    v-if="!retiroParcelaSwitch"
                                    v-model="retiro.superficie"
                                    label="Total Ha para explotación ganadera"
                                    maximumFractionDigits="2"
                                    :rules="nonNegativeRules"
                                    dense
                                  ></fh-number>

                                  <!-- parcelas del retiro -->
                                  <template v-if="retiroParcelaSwitch">
                                    <v-subheader class="pl-0 black--text"
                                      >Parcelas</v-subheader
                                    >
                                    <v-card
                                      v-for="(
                                        parcela, indexP
                                      ) in retiro.parcelasRetiroTemp"
                                      :key="'parcela-' + indexP"
                                      class="mt-5 mb-5 fh-new"
                                      flat
                                    >
                                      <v-card-text>
                                        <v-btn
                                          @click="
                                            eliminarParcealRetiroNuevo(
                                              index,
                                              indexP
                                            )
                                          "
                                          fab
                                          small
                                          top
                                          right
                                          depressed
                                          absolute
                                          class="fh-fab-btn"
                                        >
                                          <v-icon>fa-times</v-icon>
                                        </v-btn>

                                        <v-text-field
                                          v-model="parcela.nombre"
                                          label="Nombre de la parcela"
                                          ref="nombre"
                                          :rules="commonRules"
                                          :counter="parcelaNombreLength"
                                          dense
                                          class="pb-2"
                                        >
                                        </v-text-field>

                                        <fh-number
                                          v-model="parcela.superficie"
                                          label="Total Ha"
                                          maximumFractionDigits="2"
                                          :rules="nonNegativeRules"
                                          dense
                                          class="pb-2"
                                        ></fh-number>

                                        <v-text-field
                                          v-model="parcela.comentario"
                                          label="Comentario"
                                          :rules="comentarioRules"
                                          :counter="comentarioLength"
                                          dense
                                        >
                                        </v-text-field>
                                      </v-card-text>
                                    </v-card>
                                  </template>

                                  <v-btn
                                    v-if="retiroParcelaSwitch"
                                    @click="agregarParcelaRetiro(index)"
                                    outlined
                                    rounded
                                    color="#90caf9"
                                    class="mt-1 mb-4"
                                  >
                                    <v-icon left small>fa-plus</v-icon>
                                    Agregar Parcela
                                  </v-btn>
                                </v-card-text>
                              </v-card>
                              <!-- retiros a eliminar -->
                              <v-card
                                v-for="(retiro, index) in retirosListToDelete"
                                :key="'retirosSavedEliminar-' + index"
                                class="mb-5 fh-eliminar"
                                flat
                              >
                                <v-card-text>
                                  <v-btn
                                    @click="
                                      revertirRetirosEliminados(index, retiro)
                                    "
                                    fab
                                    small
                                    top
                                    right
                                    depressed
                                    absolute
                                    class="fh-fab-btn"
                                  >
                                    <v-icon>fa-undo-alt</v-icon>
                                  </v-btn>
                                  Retiro a eliminar
                                  <v-text-field
                                    v-model="retiro.nombre"
                                    label="Nombre"
                                    ref="nombreDelete"
                                    :rules="commonRules"
                                    :counter="retiroNombreLength"
                                    dense
                                    class="pb-2"
                                  >
                                  </v-text-field>
                                  <fh-number
                                    v-if="retiro.superficie !== 0"
                                    v-model="retiro.superficie"
                                    label="Total Ha para explotación ganadera"
                                    maximumFractionDigits="2"
                                    :rules="nonNegativeRules"
                                    dense
                                  ></fh-number>
                                </v-card-text>
                              </v-card>
                              <v-btn
                                :disabled="optionRadio !== 2"
                                @click="agregarRetiro"
                                outlined
                                rounded
                                color="#90caf9"
                                class="mx-0 mb-4"
                              >
                                <v-icon left small>fa-plus</v-icon>
                                Agregar Retiro
                              </v-btn>
                            </template>
                          </v-card-text>
                          <v-card-actions
                            class="justify-end pr-4"
                            v-if="optionRadio === 2"
                          >
                            <v-btn outlined @click="cancelSaveRetiros"
                              >Cancelar</v-btn
                            >
                            <v-btn
                              @click="handleSaveRetiros"
                              color="success"
                              outlined
                              >Guardar</v-btn
                            >
                          </v-card-actions>
                        </div>
                      </v-expand-transition>
                    </v-card>

                    <!-- Opcion 3: Configuración en Parcelas -->
                    <v-card outlined class="pb-0" flat>
                      <v-card-title>
                        <v-chip color="primary" text-color="white"
                          >Opción
                          <v-avatar right class="green darken-4"> 3 </v-avatar>
                        </v-chip>
                        <v-dialog v-model="opcionTres" width="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="red lighten-2"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              icon
                            >
                              <v-icon>fa-question-circle</v-icon>
                            </v-btn>
                          </template>

                          <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                              Configuración opción 3
                            </v-card-title>

                            <v-card-text>
                              En esta configuración, la explotación ganadera se
                              divide en parcelas individuales. Para cada parcela
                              hay que definir la superficie de explotación y un
                              nombre o identificador.
                              <p></p>
                              <span class="font-weight-bold">Advertencia</span>
                              <p>
                                Si solo guarda una parcela, está será visible en
                                la Configuración 1. Si desea trabajar con la
                                opción 3, elige la configuración 3 y agregue
                                otra parcela.
                              </p>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                text
                                @click="opcionTres = false"
                              >
                                Cerrar
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-card-title>
                      <v-radio
                        label="Dividir establecimiento en parcelas"
                        :value="3"
                        class="mt-2 pl-4"
                        @change="checkTres"
                      ></v-radio>
                      <v-subheader class="py-0 black--text">
                        Parcelas
                        <v-btn icon @click="showParcelas = !showParcelas">
                          <v-icon small>{{
                            showParcelas ? "fa-chevron-up" : "fa-chevron-down"
                          }}</v-icon>
                        </v-btn>
                      </v-subheader>
                      <v-expand-transition>
                        <div v-show="showParcelas">
                          <v-card-text class="py-0">
                            <template>
                              <!-- parcelas guardadas -->
                              <v-card
                                v-for="(parcela, index) in parcelasSaved"
                                :key="'parcelaSaved-' + index"
                                class="mb-5 fh-saved"
                                flat
                              >
                                <v-card-text>
                                  <v-btn
                                    @click="
                                      eliminarParcelaSaved(index, parcela)
                                    "
                                    fab
                                    small
                                    top
                                    right
                                    depressed
                                    absolute
                                    class="fh-fab-btn"
                                  >
                                    <v-icon>fa-times</v-icon>
                                  </v-btn>

                                  <v-text-field
                                    v-model="parcela.nombre"
                                    label="Nombre"
                                    :rules="commonRules"
                                    :counter="parcelaNombreLength"
                                    dense
                                    class="pb-2"
                                  >
                                  </v-text-field>

                                  <fh-number
                                    v-model="parcela.superficie"
                                    label="Total Ha"
                                    maximumFractionDigits="2"
                                    :rules="nonNegativeRules"
                                    dense
                                    class="pb-2"
                                  ></fh-number>

                                  <v-text-field
                                    dense
                                    v-model="parcela.comentario"
                                    label="Comentario"
                                    :rules="comentarioRules"
                                    :counter="comentarioLength"
                                  >
                                  </v-text-field>
                                </v-card-text>
                              </v-card>
                              <!-- parcelas nuevas -->
                              <v-card
                                v-for="(parcela, index) in parcelasTemp"
                                :key="'parcela-' + index"
                                class="mb-5 fh-new"
                                flat
                              >
                                <v-card-text>
                                  <v-btn
                                    @click="eliminarParcelaTemp(index)"
                                    fab
                                    small
                                    top
                                    right
                                    depressed
                                    absolute
                                    class="fh-fab-btn"
                                  >
                                    <v-icon>fa-times</v-icon>
                                  </v-btn>

                                  <v-text-field
                                    dense
                                    v-model="parcela.nombre"
                                    label="Nombre"
                                    ref="nombre"
                                    :disabled="optionRadio !== 3"
                                    :rules="commonRules"
                                    :counter="parcelaNombreLength"
                                    class="pb-2"
                                  >
                                  </v-text-field>

                                  <fh-number
                                    dense
                                    v-model="parcela.superficie"
                                    label="Total Ha"
                                    maximumFractionDigits="2"
                                    :disabled="optionRadio !== 3"
                                    :rules="nonNegativeRules"
                                    class="pb-2"
                                  ></fh-number>

                                  <v-text-field
                                    dense
                                    v-model="parcela.comentario"
                                    label="Comentario"
                                    :disabled="optionRadio !== 3"
                                    :rules="comentarioRules"
                                    :counter="comentarioLength"
                                  >
                                  </v-text-field>
                                </v-card-text>
                              </v-card>
                              <!-- parcelas a eliminar -->
                              <v-card
                                v-for="(parcela, index) in parcelasListToDelete"
                                :key="'parcelasSavedEliminar-' + index"
                                class="mb-5 fh-eliminar"
                                flat
                              >
                                <v-card-text>
                                  <v-btn
                                    @click="
                                      revertirParcelasEliminadas(index, parcela)
                                    "
                                    fab
                                    small
                                    top
                                    right
                                    depressed
                                    absolute
                                    class="fh-fab-btn"
                                  >
                                    <v-icon>fa-times</v-icon>
                                  </v-btn>
                                  Parcela a eliminar
                                  <v-text-field
                                    dense
                                    v-model="parcela.nombre"
                                    label="Nombre"
                                    ref="nombreDelete"
                                    :rules="commonRules"
                                    :counter="parcelaNombreLength"
                                    readonly
                                    class="pb-2"
                                  >
                                  </v-text-field>
                                  <fh-number
                                    dense
                                    v-model="parcela.superficie"
                                    label="Total Ha"
                                    maximumFractionDigits="2"
                                    :rules="nonNegativeRules"
                                    readonly
                                    class="pb-2"
                                  ></fh-number>
                                  <v-text-field
                                    dense
                                    v-model="parcela.comentario"
                                    label="Comentario"
                                    :rules="comentarioRules"
                                    :counter="comentarioLength"
                                    readonly
                                  >
                                  </v-text-field>
                                </v-card-text>
                              </v-card>
                              <v-btn
                                :disabled="optionRadio !== 3"
                                @click="agregarParcela"
                                outlined
                                rounded
                                color="#90caf9"
                                class="mx-0 mb-4"
                              >
                                <v-icon left small>fa-plus</v-icon>
                                Agregar Parcela
                              </v-btn>
                            </template>
                          </v-card-text>
                          <v-card-actions class="justify-end pr-4">
                            <v-btn
                              :disabled="optionRadio !== 3"
                              @click="cancelSaveParcelas"
                              outlined
                              >Cancelar</v-btn
                            >
                            <v-btn
                              :disabled="optionRadio !== 3"
                              @click="handleSaveParcelas"
                              color="success"
                              outlined
                              >Guardar</v-btn
                            >
                          </v-card-actions>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-radio-group>
                </v-form>
              </v-card>
            </div>
          </v-expand-transition>
        </v-card>
      </v-card-text>
    </v-card>

    <!-- Dialog for adding and editing establecimientos -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <fh-crud-establecimientos
        :formTitle="formTitle"
        :editData="editData"
        v-on:terminated="closeDialog"
      >
      </fh-crud-establecimientos>
    </v-dialog>
    <!-- Dialog for deleting establecimientos -->
    <v-dialog v-model="eliminarDialog" max-width="640px" persistent>
      <v-card>
        <v-card-title class="headline justify-center text-break"
          >¿Está seguro que quiere eliminar este establecimiento?</v-card-title
        >
        <v-card-text>
          <v-row class="ml-1"
            ><v-col class="mr-2"
              ><span class="font-weight-bold"
                >Nombre del establecimiento:</span
              ></v-col
            ><v-col
              ><span class="font-weight-medium">{{
                editedEstablecimiento.nombre
              }}</span></v-col
            ></v-row
          >
          <v-row class="ml-1 mt-0"
            ><v-col class="mr-2"
              ><span class="font-weight-bold">Zona:</span></v-col
            ><v-col
              ><span class="font-weight-medium">{{
                editedEstablecimiento.idZona
              }}</span></v-col
            ></v-row
          >
          <v-row class="ml-1 mt-0">
            <v-col class="mr-2"
              ><span class="font-weight-bold">Tipo explotación:</span></v-col
            >
            <v-col>
              <v-row class="mt-0 mb-1 ml-0" v-if="categoriaExpAgro !== 0"
                ><span class="font-weight-medium"
                  >Agricultura <v-icon color="primary" small>fa-seedling</v-icon
                  ><span class="font-weight-bold grey--te ml-2">Grupo: </span
                  ><span class="grey--text">{{ tipoGrupoExpAgro }}</span></span
                ></v-row
              >
              <v-row class="mt-0 ml-0" v-if="categoriaExpGanaderia !== 0"
                ><span class="font-weight-medium"
                  >Ganadería <v-icon color="brown" small>{{ cowIcon }}</v-icon
                  ><span class="font-weight-bold ml-3">Grupo: </span
                  ><span class="grey--text">{{
                    tipoGrupoExpGanaderia
                  }}</span></span
                ></v-row
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="text-center red--text"
          ><v-icon left color="red">fa-exclamation-triangle</v-icon>¡Si elimina
          el establecimiento, se borrarán todos los datos asociados a este y no
          será posible recuperarlos!</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="error" text @click="deleteEstablecimientoConfirm"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog for adding explotacion -->
    <v-dialog v-model="addExplotacion" max-width="570px" persistent>
      <v-card>
        <v-card-title class="justify-center text-break">{{
          addExplotacionTitle
        }}</v-card-title>
        <v-form v-model="valid" ref="addExpForm">
          <v-card-text
            class="px-6"
            v-if="
              listaGrupos.length > 1 ||
              (listaGrupos.length !== 0 && listaGrupos[0].tipo === 1)
            "
          >
            <v-autocomplete
              :rules="grupoExpRules"
              :items="listaGrupos"
              v-model="newExplotacion"
              label="Grupo Explotación"
              outlined
              item-text="nombre"
              item-value="idGrupoExplotacion"
              hide-no-data
              required
              dense
            >
            </v-autocomplete>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="cancelarAddExplotacion"
            >Cancelar</v-btn
          >
          <v-btn color="primary" text @click="saveNuevaExplotacion"
            >Agregar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog for deleting explotacion -->
    <v-dialog v-model="deleteExplotacion" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline justify-center text-break">{{
          deleteExplotacionTitle
        }}</v-card-title>
        <v-card-text
          >Si se elimina la explotación, todos los datos relacionados serán
          eliminados</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="cancelarDebajaExplotacion"
            >Cancelar</v-btn
          >
          <v-btn color="error" text @click="confirmarDebajaExplotacion"
            >Dar debaja</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for droping configuracion 1 -->
    <v-dialog v-model="dropUno" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline justify-center text-break"
          >¿Está seguro que quiere cambiar la configuración de
          explotación?</v-card-title
        >
        <v-card-text
          >Si elige cambiar la configuración, se eliminarán los registros
          guardados de la configuración anterior</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="closeDropUno">Cancelar</v-btn>
          <v-btn color="success" text @click="deleteConfigUno">Cambiar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog for droping configuracion 2 -->
    <v-dialog v-model="dropTwo" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline justify-center text-break"
          >¿Está seguro que quiere cambiar la configuración de
          explotación?</v-card-title
        >
        <v-card-text
          >Si elige cambiar la configuración, se eliminarán los registros
          guardados para los retiros de la configuración anterior</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="closeDropTwo">Cancelar</v-btn>
          <v-btn color="success" text @click="deleteConfigTwo">Cambiar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog for droping configuracion 3 -->
    <v-dialog v-model="dropTree" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline justify-center text-break"
          >¿Está seguro que quiere cambiar la configuración de
          explotación?</v-card-title
        >
        <v-card-text
          >¡Si elige cambiar la configuración, se eliminarán los registros
          guardados para las parcelas de la configuración anterior!</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="closeDropTree">Cancelar</v-btn>
          <v-btn color="success" text @click="deleteConfigTree">Cambiar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </fh-container>
</template>

<script>
import ConfiguracionRepository from "@/services/ConfiguracionRepository";
import FhCrudEstablecimientos from "@/components/app/FhCrudEstablecimientos.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { mdiCow } from "@mdi/js";
import FhContainer from "@/components/FhContainer.vue";
import FhNumber from "@/components/FhNumber.vue";
import isequal from "lodash.isequal";
import cloneDeep from "lodash.clonedeep";
import FhEstablecimientoMenu from "@/components/app/FhEstablecimientoMenu.vue";
import FhDebajaFichaGanadera from "@/components/app/FhDebajaFichaGanadera.vue";

export default {
  name: "ConfiguracionEstablecimientos",
  components: {
    FhCrudEstablecimientos,
    FhContainer,
    FhNumber,
    FhEstablecimientoMenu,
    FhDebajaFichaGanadera,
  },
  data() {
    return {
      establecimientoMenu: false,
      cowIcon: mdiCow,
      dialog: false,
      addExplotacion: false,
      addExplotacionTitle: null,
      deleteExplotacionTitle: null,
      deleteExplotacion: false,
      listaGrupos: [],
      newExplotacion: null,
      debajaExplotacion: null,
      opcionUno: false,
      opcionDos: false,
      opcionTres: false,
      optionRadio: null,
      dropUno: false,
      dropTwo: false,
      dropTree: false,
      parcelaChange: false,
      eliminarDialog: false,
      editedIndex: -1,
      editData: null,
      editedEstablecimiento: {
        idEstablecimiento: 0,
        idAgricultor: 0,
        idZona: 0,
        nombre: "",
      },
      defaultEstablecimiento: {
        idEstablecimiento: 0,
        idAgricultor: 0,
        idZona: 0,
        nombre: "",
      },
      categoriaExpAgro: 0,
      categoriaExpGanaderia: 0,
      tipoGrupoExpAgro: null,
      tipoGrupoExpGanaderia: null,
      showAdvanced: false,
      retiroParcelaSwitch: false,
      showRetiros: false,
      showParcelas: false,
      savedParcela: {
        nombre: "",
        superficie: 0,
        comentario: "",
        idRetiro: null,
      },
      editedParcela: {
        nombre: "",
        superficie: 0,
        comentario: "",
        idRetiro: null,
      },
      defaultParcela: {
        nombre: "",
        superficie: 0,
        comentario: "",
        idRetiro: null,
      },
      defaultRetiro: {
        idRetiro: 0,
        idEstablecimiento: 0,
        nombre: "",
        superficie: 0,
        parcelasRetiroTemp: [],
        parcelasSaved: [],
        parcelasListToDelete: [],
      },
      parcelasTemp: [],
      parcelasSaved: [],
      parcelasListToDelete: [],
      retirosTemp: [],
      retirosSaved: [],
      retirosListToDelete: [],
      //Configuracion Avanzada form
      valid: false,
      saveDisabled: false,
      parcelaNombreLength: 30,
      retiroNombreLength: 30,
      comentarioLength: 50,
      commonRules: [
        (v) => !!v || "Campo obligatorio",
        (v) =>
          !v ||
          v.length <= this.parcelaNombreLength ||
          `No debe superar ${this.parcelaNombreLength} caracteres`,
      ],
      nonNegativeRules: [
        (v) => !!v || "Campo obligatorio",
        (v) => v >= 0 || "No puede ser negativo",
      ],
      comentarioRules: [
        (v) =>
          !v ||
          v.length <= this.comentarioLength ||
          `No debe superar ${this.comentarioLength} caracteres`,
      ],
      grupoExpRules: [(v) => !!v || "Campo obligatorio"],
    };
  },
  computed: {
    ...mapState("session", ["isRestored"]),
    ...mapState("establecimientos", [
      "establecimiento",
      "establecimientosList",
      "grupoExplotacionList",
      "lastEstablecimiento",
    ]),
    ...mapState("agricultor", ["listaGrupoExplotacion", "agricultor"]),
    ...mapState("fichas", ["fichaGanadera", "parcelas"]),
    ...mapState("temporada", ["temporada"]),
    ...mapState("retiros", ["listaRetiros"]),
    ...mapGetters("establecimientos", [
      "isEstablecimientoSet",
      "hasCategoriaAgricultura",
      "hasCategoriaGanaderia",
      "filteredEstablecimientoList",
      "ganaderiaExplotacion",
      "currentCategoria",
    ]),
    ...mapGetters("fichas", ["isFichaGanaderaSet", "getParcela"]),
    ...mapGetters("retiros", ["getRetiro"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Agregar un Establecimiento"
        : "Editar Establecimiento";
    },
    canAddExplotacionGanadera() {
      return (
        this.listaGrupoExplotacion.listaGanaderia.filter(
          (item) => item.tipo !== 0
        ).length !== 0
      );
    },
    canAddExplotacionAgricola() {
      return (
        this.listaGrupoExplotacion.listaAgro.filter((item) => item.tipo !== 0)
          .length !== 0
      );
    },
  },
  watch: {
    eliminarDialog(val) {
      val || this.close();
    },
    dialog(val) {
      val || this.close();
    },
    establecimientosList() {
      if (
        this.establecimientosList.length === 0 &&
        this.lastEstablecimiento === 0 &&
        this.establecimiento.idEstablecimiento === 0
      ) {
        this.$router
          .push({ name: "CrearEstablecimiento" })
          .then()
          .catch((e) => {});
      }
    },
  },
  methods: {
    ...mapActions("establecimientos", [
      "fetchEstablecimientosList",
      "clearEstablecimiento",
      "clearEstablecimientoList",
      "setEstablecimiento",
    ]),
    ...mapActions("agricultor", ["fetchListaGrupoExplotacion"]),
    ...mapActions("snackbar", ["showSnackbar"]),
    ...mapActions("zonas", ["fetchListaZona"]),
    ...mapActions("fichas", ["fetchFichaGanadera", "clearFichaGanadera"]),
    ...mapActions("retiros", ["fetchListaRetiros", "clearListaRetiros"]),
    ...mapActions("temporada", ["fetchListaTemporada"]),
    async addFichaGanadera() {
      await ConfiguracionRepository.crearFichaGanadera(
        this.establecimiento.idEstablecimiento,
        this.ganaderiaExplotacion.idGrupoExplotacion,
        this.temporada.idTemporada
      );
      await this.fetchFichaGanadera();
    },
    changeDefault() {
      this.parcelaChange = true;
    },

    agregarExplotacion(categoria) {
      this.listaGrupos = [];
      this.addExplotacionTitle =
        categoria === 1
          ? "¿Agregar explotación de Agricultura al establecimiento?"
          : "¿Agregar explotación Ganadera al establecimiento?";
      this.listaGrupos =
        categoria === 1
          ? this.listaGrupoExplotacion.listaAgro.filter(
              (item) => item.tipo !== 0
            )
          : this.listaGrupoExplotacion.listaGanaderia.filter(
              (item) => item.tipo !== 0
            );
      this.addExplotacion = true;
    },
    async saveNuevaExplotacion() {
      try {
        if (!this.$refs.addExpForm.validate()) {
          return;
        }
        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (!this.newExplotacion && this.listaGrupos.length !== 0) {
            this.newExplotacion = this.listaGrupos[0].idGrupoExplotacion;
          }
          await ConfiguracionRepository.agregarGrupoExplotacion(
            this.agricultor.idAgricultor,
            this.establecimiento.idEstablecimiento,
            this.newExplotacion
          );
          let temp = this.listaGrupos.find(
            (item) => item.idGrupoExplotacion === this.newExplotacion
          );

          let tempEstablecimiento = this.establecimiento;
          if (temp.categoria === 2) {
            await ConfiguracionRepository.crearFichaGanadera(
              tempEstablecimiento.idEstablecimiento,
              this.newExplotacion,
              this.temporada.idTemporada
            );
            await ConfiguracionRepository.crearLoteAnimalPredeterminado(
              this.agricultor.idAgricultor,
              tempEstablecimiento.idEstablecimiento
            );
          }
          this.newExplotacion === null;
          this.listaGrupos = [];
          this.cancelarAddExplotacion();
          this.saveDisabled = false;

          this.clearEstablecimientoList();
          this.fetchEstablecimientosList(this.agricultor.idAgricultor);
        }
      } catch (e) {
        this.saveDisabled = false;
      } finally {
        this.$refs.addExpForm.resetValidation();
      }
    },
    cancelarAddExplotacion() {
      this.addExplotacionTitle = null;
      this.addExplotacion = false;
      this.newExplotacion = null;
      this.$refs.addExpForm.resetValidation();
    },
    cancelarDebajaExplotacion() {
      this.deleteExplotacionTitle = null;
      this.deleteExplotacion = false;
      this.debajaExplotacion = null;
    },
    abirDebajaExplotacion(categoria) {
      this.deleteExplotacionTitle =
        categoria === 1
          ? "¿Dar debaja de la explotación Agricultura del establecimiento?"
          : "¿Dar debaja de la explotación Ganadera del establecimiento?";
      this.deleteExplotacion = true;
      this.debajaExplotacion = this.establecimiento.grupoExplotacionList.find(
        (item) => item.categoria === categoria
      ).idGrupoExplotacion;
    },
    async confirmarDebajaExplotacion() {
      try {
        await ConfiguracionRepository.debajaGrupoExplotacion(
          this.agricultor.idAgricultor,
          this.establecimiento.idEstablecimiento,
          this.debajaExplotacion
        );
        this.cancelarDebajaExplotacion();
        this.clearEstablecimiento();
        this.clearEstablecimientoList();
        this.fetchEstablecimientosList(this.agricultor.idAgricultor);
      } catch (e) {}
    },

    checkUno() {
      if (this.optionRadio === 2) {
        this.dropTwo = true;
      } else if (this.optionRadio === 3) {
        this.dropTree = true;
      }
    },
    closeDropUno() {
      this.dropUno = false;
      this.optionRadio = 1;
    },
    async deleteConfigUno() {
      this.dropUno = false;
      if (this.optionRadio === 3 && this.savedParcela.superficie !== 0) {
        this.parcelasSaved.push(Object.assign({}, this.savedParcela));
      } else {
        try {
          if (this.savedParcela.superficie !== 0) {
            await ConfiguracionRepository.debajaParcelaGanadera(
              this.savedParcela.idParcelaGanadera
            );

            await this.clearFichaGanadera();
            await this.fetchFichaGanadera();
          }
        } catch (e) {}
      }
      this.editedParcela = Object.assign({}, this.defaultParcela);
      this.savedParcela = Object.assign({}, this.defaultParcela);
    },

    checkDos() {
      if (this.optionRadio === 1) {
        this.dropUno = true;
      } else if (this.optionRadio === 3) {
        this.dropTree = true;
      }
      this.showRetiros = true;
    },
    closeDropTwo() {
      this.dropTwo = false;
      this.optionRadio = 2;
    },
    async deleteConfigTwo() {
      this.dropTwo = false;
      try {
        for (let retiro of this.retirosSaved) {
          for (let index = 0; index < retiro.parcelasSaved.length; index++) {
            await ConfiguracionRepository.debajaParcelaGanadera(
              retiro.parcelasSaved[index].idParcelaGanadera
            );
          }
          await ConfiguracionRepository.debajaRetiro(
            this.ganaderiaExplotacion.idGrupoExplotacion,
            retiro.idRetiro
          );
        }
        await this.clearListaRetiros();
        await this.clearFichaGanadera();
        await this.fetchListaRetiros();
        await this.fetchFichaGanadera();

        this.retirosTemp = [];
        this.retirosListToDelete = [];
        this.retirosSaved = [];
      } catch (e) {}
    },

    checkTres() {
      if (this.optionRadio === 1) {
        this.dropUno = true;
      } else if (this.optionRadio === 2) {
        this.dropTwo = true;
      }
      this.showParcelas = true;
    },
    closeDropTree() {
      this.dropTree = false;
      this.optionRadio = 3;
    },
    async deleteConfigTree() {
      this.dropTree = false;
      try {
        for (let parcelaDelete of this.parcelasSaved) {
          await ConfiguracionRepository.debajaParcelaGanadera(
            parcelaDelete.idParcelaGanadera
          );
        }
        await this.clearFichaGanadera();
        await this.fetchFichaGanadera();

        this.parcelasTemp = [];
        this.parcelasListToDelete = [];
        this.parcelasSaved = [];
      } catch (e) {}
    },

    //Manejo Parcelas
    agregarParcela() {
      this.parcelasTemp.push(Object.assign({}, this.defaultParcela));
      this.$nextTick(() => {
        this.$refs.nombre[this.parcelasTemp.length - 1].focus();
      });
    },
    eliminarParcelaTemp(index) {
      this.parcelasTemp.splice(index, 1);
    },
    eliminarParcelaSaved(index, parcela) {
      this.parcelasSaved.splice(index, 1);
      this.parcelasListToDelete.push(parcela);
    },
    revertirParcelasEliminadas(index, parcela) {
      this.parcelasListToDelete.splice(index, 1);
      this.parcelasSaved.push(parcela);
    },
    isParcelaModified(parcela) {
      let parcelaCheck = this.getParcela(parcela.idParcelaGanadera);
      return (
        parcelaCheck.superficie !== parcela.superficie ||
        parcelaCheck.comentario !== parcela.comentario ||
        parcelaCheck.nombre !== parcela.nombre
      );
    },
    async handleSaveParcelas() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (!this.fichaGanadera.idFichaGanadera) {
          await this.fetchFichaGanadera();
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;

          if (this.parcelasTemp.length !== 0) {
            await ConfiguracionRepository.crearParcelaGanadera(
              this.fichaGanadera.idFichaGanadera,
              this.parcelasTemp
            );
          }
          for (let parcelaDelete of this.parcelasListToDelete) {
            await ConfiguracionRepository.debajaParcelaGanadera(
              parcelaDelete.idParcelaGanadera
            );
          }
          for (let parcelaModificar of this.parcelasSaved) {
            if (this.isParcelaModified(parcelaModificar)) {
              await ConfiguracionRepository.actualizarParcelaGanadera(
                parcelaModificar.idParcelaGanadera,
                parcelaModificar
              );
            }
          }

          await this.clearFichaGanadera();
          await this.fetchFichaGanadera();

          this.parcelasTemp = [];
          this.parcelasListToDelete = [];
          this.parcelasSaved = this.parcelas.map((parcela) =>
            Object.assign({}, parcela)
          );
          this.saveDisabled = false;
        }
      } catch (e) {
        this.saveDisabled = false;
      }
    },
    cancelSaveParcelas() {
      this.parcelasTemp = [];
      this.parcelasSaved = this.parcelas.map((parcela) =>
        Object.assign({}, parcela)
      );
      this.parcelasListToDelete = [];
    },
    async handleSaveParcelaUnica() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (!this.fichaGanadera.idFichaGanadera) {
          await this.fetchFichaGanadera();
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          this.editedParcela.nombre = this.establecimiento.nombre;
          this.parcelaChange = false;
          if (this.editedParcela.nombre.length > 30) {
            this.editedParcela.nombre = this.establecimiento.nombre.substring(
              0,
              29
            );
          }

          if (isequal(this.savedParcela, this.defaultParcela)) {
            await ConfiguracionRepository.crearParcelaGanadera(
              this.fichaGanadera.idFichaGanadera,
              [this.editedParcela]
            );
            await this.clearFichaGanadera();
            await this.fetchFichaGanadera();
          } else if (
            this.savedParcela.nombre !== this.editedParcela.nombre ||
            this.savedParcela.superficie !== this.editedParcela.superficie ||
            this.savedParcela.comentario !== this.editedParcela.comentario
          ) {
            let idParcela = this.editedParcela.idParcelaGanadera;
            delete this.editedParcela.idFichaGanadera;
            delete this.editedParcela.idParcelaGanadera;

            await ConfiguracionRepository.actualizarParcelaGanadera(
              idParcela,
              this.editedParcela
            );
            await this.clearFichaGanadera();
            await this.fetchFichaGanadera();
          }

          if (this.parcelas.length === 1) {
            this.editedParcela = Object.assign({}, this.parcelas[0]);
            this.savedParcela = Object.assign({}, this.parcelas[0]);
          } else {
            this.editedParcela = Object.assign({}, this.defaultParcela);
          }
        }
      } catch (e) {
        this.saveDisabled = false;
      }
    },
    cancelSaveParcelaUnica() {
      if (this.parcelas.length !== 0) {
        this.editedParcela = Object.assign({}, this.parcelas[0]);
        this.savedParcela = Object.assign({}, this.parcelas[0]);
        this.parcelaChange = false;
      } else {
        this.editedParcela = Object.assign({}, this.defaultParcela);
        this.savedParcela = Object.assign({}, this.defaultParcela);
      }
    },

    //Manejo Retiros
    agregarRetiro() {
      this.retirosTemp.push(cloneDeep(this.defaultRetiro));
      this.$nextTick(() => {
        this.$refs.nombreNuevo[this.retirosTemp.length - 1].focus();
      });
    },
    agregarParcelaRetiro(index) {
      this.retirosTemp[index].parcelasRetiroTemp.push(
        Object.assign({}, this.defaultParcela)
      );
    },
    agregarParcelaRetiroSaved(index) {
      this.retirosSaved[index].parcelasRetiroTemp.push(
        cloneDeep(this.defaultParcela)
      );
      this.retirosSaved[index].parcelasRetiroTemp[
        this.retirosSaved[index].parcelasRetiroTemp.length - 1
      ].idRetiro = this.retirosSaved[index].idRetiro;
    },
    eliminarRetiroTemp(index) {
      this.retirosTemp.splice(index, 1);
    },
    eliminarParcealRetiroNuevo(index, indexParcela) {
      this.retirosTemp[index].parcelasRetiroTemp.splice(indexParcela, 1);
    },
    eliminarParcelaRetiroTemp(index, indexParcela) {
      this.retirosSaved[index].parcelasRetiroTemp.splice(indexParcela, 1);
    },
    eliminarParcelaRetiroSaved(index, indexParcela, parcela) {
      this.retirosSaved[index].parcelasSaved.splice(indexParcela, 1);
      this.retirosSaved[index].parcelasListToDelete.push(parcela);
    },
    revertirParcelaRetiroSaved(index, indexParcela, parcela) {
      this.retirosSaved[index].parcelasListToDelete.splice(indexParcela, 1);
      this.retirosSaved[index].parcelasSaved.push(parcela);
    },
    eliminarRetiroSaved(index, retiro) {
      this.retirosSaved.splice(index, 1);
      this.retirosListToDelete.push(retiro);
    },
    revertirRetirosEliminados(index, retiro) {
      this.retirosListToDelete.splice(index, 1);
      this.retirosSaved.push(retiro);
    },
    isRetiroModified(idRetiro, nombre) {
      let retiro = this.getRetiro(idRetiro);
      return retiro.nombre !== nombre;
    },
    async handleSaveRetiros() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (!this.fichaGanadera.idFichaGanadera) {
          await this.fetchFichaGanadera();
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.retirosTemp.length !== 0) {
            let retirosToCrear = [];
            this.retirosTemp.map((temp) =>
              retirosToCrear.push({ nombre: temp.nombre })
            );
            let creados = await ConfiguracionRepository.crearRetiro(
              this.establecimiento.idEstablecimiento,
              this.ganaderiaExplotacion.idGrupoExplotacion,
              retirosToCrear
            );
            for (let temp of this.retirosTemp) {
              let parcelas = [];
              let retiroCreado = creados.find(
                (creado) => creado.nombre === temp.nombre
              );
              let index = creados.findIndex(
                (retiro) => retiro.nombre === temp.nombre
              );

              if (index >= 0) {
                if (temp.parcelasRetiroTemp.length !== 0) {
                  temp.parcelasRetiroTemp = temp.parcelasRetiroTemp.map(
                    (parcela) => {
                      return {
                        nombre: parcela.nombre,
                        superficie: parcela.superficie,
                        comentario: parcela.comentario,
                        idRetiro: retiroCreado.idRetiro,
                      };
                    }
                  );
                  await ConfiguracionRepository.crearParcelaGanadera(
                    this.fichaGanadera.idFichaGanadera,
                    temp.parcelasRetiroTemp
                  );
                } else {
                  let parcela = {
                    nombre: retiroCreado.nombre,
                    superficie: temp.superficie,
                    comentario: "",
                    idRetiro: retiroCreado.idRetiro,
                  };
                  parcelas.push(parcela);
                  await ConfiguracionRepository.crearParcelaGanadera(
                    this.fichaGanadera.idFichaGanadera,
                    parcelas
                  );
                }
                creados.splice(index, 1);
              }
            }
          }
          for (let retiroDelete of this.retirosListToDelete) {
            // Eliminar parcelas guardadas
            for (
              let index = 0;
              index < retiroDelete.parcelasSaved.length;
              index++
            ) {
              await ConfiguracionRepository.debajaParcelaGanadera(
                retiroDelete.parcelasSaved[index].idParcelaGanadera
              );
            }
            // Eliminar parcelas que estaban en listado para ser eliminados del retiro
            for (
              let index = 0;
              index < retiroDelete.parcelasListToDelete.length;
              index++
            ) {
              await ConfiguracionRepository.debajaParcelaGanadera(
                retiroDelete.parcelasListToDelete[index].idParcelaGanadera
              );
            }
            await ConfiguracionRepository.debajaRetiro(
              this.ganaderiaExplotacion.idGrupoExplotacion,
              retiroDelete.idRetiro
            );
          }
          for (let retiroModificado of this.retirosSaved) {
            if (retiroModificado.superficie !== 0) {
              retiroModificado.parcelasSaved[0].superficie =
                retiroModificado.superficie;
            }
            if (
              this.isRetiroModified(
                retiroModificado.idRetiro,
                retiroModificado.nombre
              )
            ) {
              await ConfiguracionRepository.actualizarRetiro(
                this.ganaderiaExplotacion.idGrupoExplotacion,
                retiroModificado.idRetiro,
                retiroModificado.nombre
              );
            }
            for (
              let index = 0;
              index < retiroModificado.parcelasRetiroTemp.length;
              index++
            ) {
              await ConfiguracionRepository.crearParcelaGanadera(
                this.fichaGanadera.idFichaGanadera,
                [retiroModificado.parcelasRetiroTemp[index]]
              );
            }
            for (
              let index = 0;
              index < retiroModificado.parcelasSaved.length;
              index++
            ) {
              if (
                this.isParcelaModified(retiroModificado.parcelasSaved[index])
              ) {
                retiroModificado.parcelasSaved[index].nombre =
                  retiroModificado.nombre;
                retiroModificado.parcelasSaved[index].idRetiro =
                  retiroModificado.idRetiro;
                delete retiroModificado.parcelasSaved[index].retiro;
                await ConfiguracionRepository.actualizarParcelaGanadera(
                  retiroModificado.parcelasSaved[index].idParcelaGanadera,
                  retiroModificado.parcelasSaved[index]
                );
              }
            }
            for (
              let index = 0;
              index < retiroModificado.parcelasListToDelete.length;
              index++
            ) {
              await ConfiguracionRepository.debajaParcelaGanadera(
                retiroModificado.parcelasListToDelete[index].idParcelaGanadera
              );
            }
          }
          await this.clearListaRetiros();
          await this.clearFichaGanadera();
          await this.fetchListaRetiros();
          await this.fetchFichaGanadera();

          this.retirosTemp = [];
          this.retirosListToDelete = [];
          this.retirosSaved = [];
          this.prepararRetiros();
          this.saveDisabled = false;
        }
      } catch (e) {
        this.saveDisabled = false;
      }
    },
    cancelSaveRetiros() {
      this.retirosSaved = this.listaRetiros.map((retiro) =>
        Object.assign({}, retiro)
      );
      this.retirosSaved.map(
        (retiro) =>
          (retiro.parcela =
            Object.assign(
              {},
              this.parcelas.find(
                (parcela) =>
                  parcela.retiro && parcela.retiro.idRetiro === retiro.idRetiro
              )
            ) || null)
      );

      this.retirosTemp = [];
      this.retirosListToDelete = [];
    },

    //Manejo Establecimientos
    async handleElegirEstablecimiento(establecimiento) {
      await this.clearEstablecimiento();
      await this.setEstablecimiento(establecimiento);
      if (this.currentCategoria === 2) {
        this.prepararParcelas();
      }
    },
    async abrirDialog() {
      await this.fetchListaGrupoExplotacion(this.agricultor.idAgricultor);
      await this.fetchListaZona();

      if (
        this.listaGrupoExplotacion.listaAgro.length === 0 &&
        this.listaGrupoExplotacion.listaGanaderia.length === 0 &&
        this.listaGrupoExplotacion.listaParticular.length === 0
      ) {
        this.showSnackbar([
          "Usted no tiene permisos para agregar nuevos Establecimientos a este Agricultor",
        ]);
        return;
      }

      this.dialog = true;
    },
    async editarEstablecimiento(establecimiento) {
      this.editedIndex = this.agricultor.idAgricultor;

      this.editedEstablecimiento = {
        idEstablecimiento: establecimiento.idEstablecimiento,
        idAgricultor: establecimiento.idAgricultor,
        idZona: establecimiento.idZona,
        nombre: establecimiento.nombre,
      };

      establecimiento.grupoExplotacionList.map((grupo) => {
        grupo.categoria === 1
          ? ((this.categoriaExpAgro = 1),
            (this.tipoGrupoExpAgro = grupo.idGrupoExplotacion))
          : ((this.categoriaExpGanaderia = 2),
            (this.tipoGrupoExpGanaderia = grupo.idGrupoExplotacion));
      });

      this.editData = {
        editedEstablecimiento: this.editedEstablecimiento,
        categoriaExpGanaderia: this.categoriaExpGanaderia,
        categoriaExpAgro: this.categoriaExpAgro,
        tipoGrupoExpAgro: this.tipoGrupoExpAgro,
        tipoGrupoExpGanaderia: this.tipoGrupoExpGanaderia,
      };

      await this.fetchListaGrupoExplotacion(this.agricultor.idAgricultor);
      await this.fetchListaZona();

      if (
        this.listaGrupoExplotacion.listaAgro.length === 0 &&
        this.listaGrupoExplotacion.listaGanaderia.length === 0 &&
        this.listaGrupoExplotacion.listaParticular.length === 0
      ) {
        this.showSnackbar([
          "Usted no tiene permisos para agregar nuevos Establecimientos a este Agricultor",
        ]);
        return;
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.eliminarDialog = false;
    },
    deleteEstablecimiento(establecimiento) {
      this.editedEstablecimiento = {
        idEstablecimiento: establecimiento.idEstablecimiento,
        idAgricultor: establecimiento.idAgricultor,
        idZona: establecimiento.zona.nombre,
        nombre: establecimiento.nombre,
      };
      establecimiento.grupoExplotacionList.map((grupo) => {
        grupo.categoria === 1
          ? ((this.categoriaExpAgro = 1),
            (this.tipoGrupoExpAgro = grupo.nombre))
          : ((this.categoriaExpGanaderia = 2),
            (this.tipoGrupoExpGanaderia = grupo.nombre));
      });

      this.eliminarDialog = true;
    },
    async deleteEstablecimientoConfirm() {
      await ConfiguracionRepository.debajaEstablecimiento(
        this.agricultor.idAgricultor,
        this.editedEstablecimiento.idEstablecimiento
      );

      if (
        this.editedEstablecimiento.idEstablecimiento ===
        this.lastEstablecimiento
      ) {
        await this.clearEstablecimiento();
      }
      await this.clearEstablecimientoList();

      this.closeDelete();
    },
    async closeDelete() {
      this.eliminarDialog = false;
      this.$nextTick(() => {
        this.editedEstablecimiento = Object.assign(
          {},
          this.defaultEstablecimiento
        );
        this.categoriaExpGanaderia = 0;
        this.categoriaExpAgro = 0;
        this.tipoGrupoExpAgro = null;
        this.tipoGrupoExpGanaderia = null;
      });
      await this.fetchEstablecimientosList(this.agricultor.idAgricultor);

      if (this.establecimientosList.length === 0) {
        this.$router.push({ name: "CrearEstablecimiento" }).catch((e) => {});
      }
      this.prepararParcelas();
    },
    async closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedEstablecimiento = Object.assign(
          {},
          this.defaultEstablecimiento
        );
        this.categoriaExpGanaderia = 0;
        this.categoriaExpAgro = 0;
        this.tipoGrupoExpAgro = null;
        this.tipoGrupoExpGanaderia = null;
      });
      this.editData = null;
      await this.fetchEstablecimientosList(this.agricultor.idAgricultor);
      this.prepararParcelas();
    },
    prepararRetiros() {
      for (let index = 0; index < this.listaRetiros.length; index++) {
        this.retirosSaved.push(cloneDeep(this.defaultRetiro));
        this.retirosSaved[index].idRetiro = this.listaRetiros[index].idRetiro;
        this.retirosSaved[index].idEstablecimiento =
          this.listaRetiros[index].idEstablecimiento;
        this.retirosSaved[index].nombre = this.listaRetiros[index].nombre;
      }

      if (this.parcelas.length === this.listaRetiros.length) {
        this.retirosSaved.map((retiro) => {
          retiro.parcelasSaved.push(
            cloneDeep(
              this.parcelas.find(
                (parcela) =>
                  parcela.retiro && parcela.retiro.idRetiro === retiro.idRetiro
              )
            )
          );
          retiro.superficie = retiro.parcelasSaved[0].superficie;
          return retiro;
        });
        this.optionRadio = 2;
        this.showRetiros = true;
      } else {
        this.retirosSaved.map((retiro) => {
          retiro.parcelasSaved = cloneDeep(
            this.parcelas.filter(
              (parcela) =>
                parcela.retiro && parcela.retiro.idRetiro === retiro.idRetiro
            )
          );
        });
        this.optionRadio = 2;
        this.showRetiros = true;
        this.retiroParcelaSwitch = true;
      }
    },
    async prepararParcelas() {
      if (this.hasCategoriaGanaderia) {
        this.optionRadio = null;
        (this.retiroParcelaSwitch = false),
          (this.showRetiros = false),
          (this.showParcelas = false),
          (this.savedParcela = {
            nombre: "",
            superficie: 0,
            comentario: "",
            idRetiro: null,
          }),
          (this.editedParcela = {
            nombre: "",
            superficie: 0,
            comentario: "",
            idRetiro: null,
          }),
          (this.defaultParcela = {
            nombre: "",
            superficie: 0,
            comentario: "",
            idRetiro: null,
          }),
          (this.defaultRetiro = {
            idRetiro: 0,
            idEstablecimiento: 0,
            nombre: "",
            superficie: 0,
            parcelasRetiroTemp: [],
            parcelasSaved: [],
            parcelasListToDelete: [],
          }),
          (this.parcelasTemp = []),
          (this.parcelasSaved = []),
          (this.parcelasListToDelete = []),
          (this.retirosTemp = []),
          (this.retirosSaved = []),
          (this.retirosListToDelete = []);

        this.clearFichaGanadera();
        this.clearListaRetiros();
        await this.fetchFichaGanadera();
        if (
          (Array.isArray(this.fichaGanadera) &&
            this.fichaGanadera.length === 0) ||
          this.fichaGanadera === null ||
          this.fichaGanadera.idFichaGanadera === null
        ) {
          this.$router.push({ name: "FaltaFichaGanadera" }).catch(() => {});
        }
        await this.fetchListaRetiros();

        if (this.parcelas.length > 1 && !this.parcelas[0].retiro) {
          this.parcelasSaved = this.parcelas.map((parcela) =>
            Object.assign({}, parcela)
          );
          this.optionRadio = 3;
          this.showParcelas = true;
        } else if (this.parcelas.length === 1 && !this.parcelas[0].retiro) {
          this.optionRadio = 1;
          this.editedParcela = Object.assign({}, this.parcelas[0]);
          this.savedParcela = Object.assign({}, this.parcelas[0]);
        } else if (this.listaRetiros.length >= 1) {
          this.prepararRetiros();
        }
      }
      if (this.parcelas.length === 0 && this.currentCategoria === 2) {
        this.showAdvanced = true;
      }
    },
  },
  async created() {
    while (!this.isRestored) {
      await this.$sleep(10);
    }
    await this.fetchEstablecimientosList(this.agricultor.idAgricultor);
    if (this.currentCategoria === 2) {
      this.prepararParcelas();
    }
    await this.fetchListaGrupoExplotacion(this.agricultor.idAgricultor);
    await this.fetchListaTemporada();
  },
};
</script>

<style scoped>
.fh-new {
  border-style: dashed;
  border-width: 2px;
  border-color: #90caf9;
}

.fh-saved {
  border-style: dashed;
  border-width: 2px;
  border-color: #4caf50;
}

.fh-eliminar {
  border-style: dashed;
  border-width: 2px;
  border-color: #ef9a9a;
}
</style>